export default __webpack_public_path__ + "static/media/team69.7d14d7ad.JPG";